import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9ff36db4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pagination" }
const _hoisted_2 = ["onClick"]

import { onMounted, ref } from 'vue';
import locations from "@/assets/json/locations.json";


export default /*#__PURE__*/_defineComponent({
  __name: 'LocationsPagination',
  emits: ['filter'],
  setup(__props, { emit: __emit }) {

const links = ref<string[]>([]);
const selected = ref<string>('');

const emit = __emit

const filter = (starts_with: string) => {
  selected.value = starts_with;
  emit('filter', starts_with);
};

onMounted(() => {
  if (locations.length) {
    let set = new Set(
      locations.map((l: any) => String(l.code).substring(0, 1).toLowerCase())
    );
    let unsorted = Array.from(set);
    links.value = unsorted.sort((code1: string, code2: string) =>
      code1.localeCompare(code2)
    );
    filter(links.value[0]);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(links.value, (link, $index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: $index,
          class: _normalizeClass(["page-item page-link", { selected: link === selected.value }]),
          onClick: ($event: any) => (filter(link))
        }, _toDisplayString(link.toUpperCase()), 11, _hoisted_2))
      }), 128))
    ])
  ]))
}
}

})